import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

const Heading = props => (
  <div className={css(styles.paragraph, props.styles)}>{props.children}</div>
);

export default Heading;

Heading.defaultProps = {
  styles: null,
};

Heading.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  children: PropTypes.string.isRequired,
};

styles = StyleSheet.create({
  paragraph: {
    fontFamily: Theme.font_family_heading,
    fontSize: Theme.font_size_heading,
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: Theme.font_weight_heading,
    marginBottom: 10,
  },
});



// WEBPACK FOOTER //
// ./src/components/Heading/index.js